import { IScoreRule } from '../interfaces/Score';

interface OptionsComparison {
    id: number,
    name: IScoreRule['comparison']
}

export const OPTIONS_COMPARISON: OptionsComparison[] = [
    { id: 0, name: '>' },
    { id: 1, name: '<' },
    { id: 2, name: '>=' },
    { id: 3, name: '<=' },
    { id: 4, name: '=' }
];
